import { inject, Injector } from '@angular/core';

export const ASYNC_DEPENDENCIES = {
  UserStore: () => import('../../../stores/user.store').then(m => m.UserStore),
  SubscriptionStore: () =>
    import('../../../stores/subscription.store').then(m => m.SubscriptionStore),
  AuthService: () => import('../../../auth/services/auth.service').then(m => m.AuthService),
} as const;

export type AsyncDependency<K extends keyof typeof ASYNC_DEPENDENCIES> = InstanceType<
  Awaited<ReturnType<(typeof ASYNC_DEPENDENCIES)[K]>>
>;

const servicesCache = new Map<string, any>();

export async function injectAsync<K extends keyof typeof ASYNC_DEPENDENCIES>(
  key: K,
  injector?: Injector
): Promise<AsyncDependency<K>> {
  const selfInjector = injector ?? inject(Injector);

  if (!servicesCache.has(key)) {
    servicesCache.set(key, await ASYNC_DEPENDENCIES[key]());
  }

  return selfInjector.get(servicesCache.get(key), undefined, { optional: false });
}
